export default __webpack_public_path__ + "locales/si/InfoPanel.json?hash=8d1936f9f9a65fb317fa0cb499899a2b";